let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("kcEOo")).then(() => parcelRequire('4ODVn'));